import { css } from 'emotion';

import { colors, fonts } from '@cobliteam/base-components/';

const linkText = css`
  font-size: ${fonts.size.smallest};
  font-weight: ${fonts.weight.medium};
  text-decoration: underline;
  color: ${colors.primary.disabled};

  :hover {
    color: ${colors.primary.disabled};
  }
`;

export default { linkText };
